class ArticleFeed extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.onClick = this.onClick.bind(this)

    this.els?.trigger?.elements.forEach((triggerEl) => {
      triggerEl.addEventListener('click', this.onClick)
    })
  }

  onClick (e) {
    if (window.BAO.MediaBreakpoints.isSmViewport) return

    const currentTriggerEl = e.target.closest(this.els?.trigger?.selector)

    e.preventDefault()

    this.els?.trigger?.elements.forEach((triggerEl) => {
      triggerEl.setAttribute(
        'aria-pressed',
        currentTriggerEl.dataset.item === triggerEl.dataset.item
          ? 'true'
          : 'false',
      )
    })

    this.els?.article?.elements.forEach((articleEl) => {
      articleEl.setAttribute(
        'aria-hidden',
        currentTriggerEl.dataset.item === articleEl.dataset.item
          ? 'false'
          : 'true',
      )
    })
  }
}

if (!customElements.get('article-feed')) {
  customElements.define('article-feed', ArticleFeed)
}
